(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function recalculateQuinconce() {
    const grid = document.querySelector('.product-grid--quinconce');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.product-grid__item'));
    const total = items.length;
    if (total === 0) return;

    // Mobile : 1 pleine largeur en premier, puis 2 côte à côte, dernier seul si impair
    if (window.innerWidth < 750) {
      const remaining = total - 1; // tout sauf le premier
      items.forEach((item, i) => {
        if (i === 0) {
          // Premier : pleine largeur
          item.style.setProperty('grid-column', '1 / -1', 'important');
        } else if (i === total - 1 && remaining % 2 !== 0) {
          // Dernier : pleine largeur si nombre impair d'items restants
          item.style.setProperty('grid-column', '1 / -1', 'important');
        } else {
          // Milieu : 2 côte à côte
          const posInPair = (i - 1) % 2;
          item.style.setProperty('grid-column', posInPair === 0 ? '1 / 2' : '2 / 3', 'important');
        }
      });
      return;
    }

    // Desktop : quinconce 8 colonnes
    const middleCount = total - 3;
    let lastRowCount = middleCount <= 4 ? middleCount : (middleCount % 4 || 4);
    const lastRowStart = total - lastRowCount;

    const row0 = ['2/4', '4/6', '6/8'];
    const middle = ['1/3', '3/5', '5/7', '7/9'];
    const lastByCount = {
      1: ['4/6'],
      2: ['3/5', '5/7'],
      3: ['2/4', '4/6', '6/8'],
      4: ['1/3', '3/5', '5/7', '7/9'],
    };

    items.forEach((item, i) => {
      let col;
      if (i < 3) {
        col = row0[i];
      } else if (i >= lastRowStart) {
        const pos = i - lastRowStart;
        col = (lastByCount[lastRowCount] || middle)[pos];
      } else {
        col = middle[(i - 3) % 4];
      }
      item.style.setProperty('grid-column', col, 'important');
    });
  }

  // Appel immédiat (le JS bundle est chargé après le DOM, donc ça marche directement)
  recalculateQuinconce();

  // Sécurité si jamais appelé avant le DOM
  document.addEventListener('DOMContentLoaded', recalculateQuinconce);
  window.addEventListener('load', recalculateQuinconce);

  // Resize avec debounce
  let _resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(recalculateQuinconce, 150);
  });

  document.addEventListener('results-list:page-loaded', recalculateQuinconce);

  const _grid = document.querySelector('.product-grid--quinconce');
  if (_grid) {
    const observer = new MutationObserver(recalculateQuinconce);
    observer.observe(_grid, { childList: true });
  }

  } catch(e) { console.error(e); }
})();
})();
